/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const AccountDetailPage = lazyLoad(
  () => import('./index'),
  module => module.AccountDetailPage
);
